import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';


import { StageQuestionnaireModel, DetailStageQuestionnaireModel, LearnerDetail } from './result.model';
import { CoreService, HttpService } from '../../services';
import { DialogService } from '../../dialog';
import { ToastService } from '../../toast';
import { AnswerModel, ChartData, ChartQuestionnaireModel, FileModel, QResult, QueovalDate } from '../../models';
import { QuestionnaireService } from '../questionnaire.service';

declare var $: any;

@Component({
  providers: [QuestionnaireService],
  selector: 'q-quest-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent implements OnInit {

  constructor
    (
      protected router: Router,
      protected indParam: CoreService,
      protected http: HttpService,
      protected dialogservice: DialogService,
      protected toastservice: ToastService,
      protected activatedRouter: ActivatedRoute,
      protected questionnaireService: QuestionnaireService,
    ) { }

  listQuestionnaire: StageQuestionnaireModel = new StageQuestionnaireModel();
  stageDetailModel: DetailStageQuestionnaireModel = new DetailStageQuestionnaireModel();
  answerModel: AnswerModel = new AnswerModel();
  noteModel: ChartQuestionnaireModel;
  statModel: ChartQuestionnaireModel;


  noteModelApres: ChartQuestionnaireModel;
  statModelApres: ChartQuestionnaireModel;

  stageName: string;
  questionnaireName: string;
  learnerSorting: string;
  nbApprenant: number;
  elQuest: any;
  resultQuest: string;
  idStage: string;
  modelType: string;
  modelName: string;
  idFormateur: string;
  apprenant: LearnerDetail;
  isCloture: boolean = false;
  disableDl: boolean = false;
  ShowStageStat: boolean = false;

  fromERP: boolean = false;
  // Mode stage erp => QuestFromStageERP
  modeQuest: string = "";

  datePickerDebutInit: QueovalDate = new QueovalDate();
  datePickerFinInit: QueovalDate = new QueovalDate();

  isAdminQuestionnaire: boolean;

  @ViewChild('closeBtn', { static: false }) closeBtn: ElementRef;
  @ViewChild('closeRaZBtn', { static: false }) closeRaZBtn: ElementRef;
  @ViewChild('scrollToLocation') scrollToLocation: ElementRef;

  @Input() set IdStage(value: string) {
    this.idStage = value;
  }

  @Input() set ModeQuest(value: string) {
    this.modeQuest = value;
  }
  //#endregion



  ngOnInit(): void {
    this.isAdminQuestionnaire = this.indParam.getAutorisation('AdminQuest');
    if (!this.questionnaireService.availableQuestionnaire) { return; }

    let _idStage: string = this.idStage ? this.idStage : '';
    let _typeQuest: string = '';
    this.activatedRouter.queryParams.subscribe(
      params => {
        _idStage ??= params['idStage'];
        _typeQuest = params['typeQuest'];
      }
    );
    this.fromERP = _idStage ? true : false;

    this.dialogservice.showSplash(false);


    this.noteModel = new ChartQuestionnaireModel();
    this.noteModel.chart = new Array<ChartData>();
    this.statModel = new ChartQuestionnaireModel();
    this.statModel.chart = new Array<ChartData>();

    this.noteModelApres = new ChartQuestionnaireModel();
    this.noteModelApres.chart = new Array<ChartData>();
    this.statModelApres = new ChartQuestionnaireModel();
    this.statModelApres.chart = new Array<ChartData>();

    this.idFormateur = this.indParam.AppParams.LoggedUser.Ident;

    this.http.getHttp<QResult<DetailStageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getTrainerStageInfo/0/0`).subscribe((data: QResult<DetailStageQuestionnaireModel>) => {
      if (!data.HasError) {
        this.stageDetailModel = data.Value;
      }
    });

    if (_idStage) {
      this.http.getHttp<QResult<StageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getInfoStage/GetStage/${_idStage}`).subscribe((data: QResult<StageQuestionnaireModel>) => {
        if (!data.HasError) {
          this.listQuestionnaire.stages = data.Value.stages;
          this.fromERP = true;

          setTimeout(() => {
            if (this.listQuestionnaire.stages.length > 0) {
              this.accordion(null, 0);
              document.getElementById(`${_idStage}${_typeQuest}`)?.click();
            }
          }, 1);
        }
      });

    } else {

      this.http.getHttp<QResult<StageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getInfoStage/trainer/${this.indParam.AppParams.LoggedUser.Ident}`).subscribe((data: QResult<StageQuestionnaireModel>) => {
        if (!data.HasError) {
          this.listQuestionnaire.stages = data.Value.stages;
          if (!this.listQuestionnaire.stages || this.listQuestionnaire.stages.length === 0) {
          }
        }
      });
    }

    this.currentTab = 'questionnaireTab';
  }

  GetStageInfo(idStage: string) {

    if (this.ShowStageStat) {
      this.ShowStageStat = false;
      this.currentTab = 'questionnaireTab';
    } else {
      this.ShowStageStat = true;
      this.currentTab = 'StatistiquePratiqueAvantApres';

      this.stageDetailModel.idStage = idStage;
      this.stageDetailModel.Mode = this.modeQuest;

      this.http.postHttp<QResult<DetailStageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getTrainerStageInfo/`, this.stageDetailModel).subscribe((data: QResult<DetailStageQuestionnaireModel>) => {
        if (!data.HasError) {
          this.stageDetailModel = data.Value;
          this.nbApprenant = this.stageDetailModel.learnerList.length;


          this.GetStatCroisee("Ques2PRO", "Ques4PRO");
        }

      });
    }
  }

  GetStatCroisee(QuestionnaireAvant: string, QuestionnaireApres: string) {
    setTimeout(() => { $('.loader').css('display', 'none'); }, 500);

    this.noteModel = new ChartQuestionnaireModel();
    this.noteModel.postModel.idStage = this.stageDetailModel.idStage;
    this.noteModel.postModel.idStagiaire = _.map(this.stageDetailModel.learnerList, 'ident').join(",");
    this.noteModel.postModel.titreQuestionnaire = QuestionnaireAvant;
    this.noteModel.Mode = 'GETNOTE';

    this.http.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Chart/`, this.noteModel).subscribe((noteData: QResult<ChartQuestionnaireModel>) => {
      if (!noteData.HasError) {
        this.noteModel = noteData.Value;
      }
    });
    this.noteModel.Mode = 'GETBARQUESTION';
    this.http.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Chart/`, this.noteModel).subscribe((questionData: QResult<ChartQuestionnaireModel>) => {
      if (!questionData.HasError) {
        this.statModel = questionData.Value;
      }
    });


    this.noteModel = new ChartQuestionnaireModel();
    this.noteModel.postModel.idStage = this.stageDetailModel.idStage;
    this.noteModel.postModel.idStagiaire = _.map(this.stageDetailModel.learnerList, 'ident').join(",");
    this.noteModel.postModel.titreQuestionnaire = QuestionnaireApres;
    this.noteModel.Mode = 'GETNOTE';

    this.http.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Chart/`, this.noteModel).subscribe((noteData: QResult<ChartQuestionnaireModel>) => {
      if (!noteData.HasError) {
        this.noteModelApres = noteData.Value;
      }
    });
    this.noteModel.Mode = 'GETBARQUESTION';
    this.http.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Chart/`, this.noteModel).subscribe((questionData: QResult<ChartQuestionnaireModel>) => {
      if (!questionData.HasError) {
        this.statModelApres = questionData.Value;
      }
    });
  }


  // reccupretation des infos des stagiaire par rapport au questionnaire selectionné
  GetTrainerStageInfo(idStage: string, modelType: string, modelName: string, stageName: string, questionnaireName: string, e?: any, isReload?: boolean): void {
    this.ShowStageStat = false;

    if (this.currentTab != 'stat') {
      this.currentTab = 'questionnaireTab';
    }
    // save navigation state
    if (!isReload) {
      if (e) {
        if (this.elQuest) { this.elQuest.target.classList.remove('active'); }
        e.currentTarget.classList.add('active');
        this.elQuest = e;
      }
    }
    this.scrollToLocation.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end' });

    this.idStage = idStage;
    this.modelType = modelType;
    this.modelName = modelName;
    this.stageName = stageName;
    this.questionnaireName = questionnaireName;

    $('.loader').css('display', 'block');
    this.stageDetailModel.idStage = idStage;
    this.stageDetailModel.Mode = this.modeQuest;
    this.stageDetailModel.modelQuestionnaire = modelType;
    this.stageDetailModel.modelNameQuestionnaire = modelName;
    this.http.postHttp<QResult<DetailStageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getTrainerStageInfo/`, this.stageDetailModel).subscribe((data: QResult<DetailStageQuestionnaireModel>) => {
      if (!data.HasError) {
        this.stageDetailModel = data.Value;
        this.nbApprenant = this.stageDetailModel.learnerList.length;
        setTimeout(() => { $('.loader').css('display', 'none'); }, 500);
      }

      // get note question
      this.noteModel = new ChartQuestionnaireModel();
      this.noteModel.postModel.idStage = this.stageDetailModel.idStage;
      this.noteModel.postModel.idStagiaire = _.map(this.stageDetailModel.learnerList, 'ident').join(",");
      this.noteModel.postModel.titreQuestionnaire = this.stageDetailModel.modelQuestionnaire;

      this.noteModel.Mode = 'GETNOTE';

      this.http.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Chart/`, this.noteModel).subscribe((noteData: QResult<ChartQuestionnaireModel>) => {
        if (!noteData.HasError) {
          this.noteModel = noteData.Value;
        }
      });
      this.noteModel.Mode = 'GETBARQUESTION';
      this.http.postHttp<QResult<ChartQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Chart/`, this.noteModel).subscribe((questionData: QResult<ChartQuestionnaireModel>) => {
        if (!questionData.HasError) {
          this.statModel = questionData.Value;
        }
      });
    });
  }

  // redirection vers la page du questionnaire
  GoToAnswer(idStage: string, model: string, idLearner: string, modelName: string): void {
    this.answerModel = new AnswerModel();
    this.answerModel.stageId = idStage;
    this.answerModel.modelType = model;
    this.answerModel.learnerId = idLearner;
    this.answerModel.modeQuestionnaire = 'trainer';
    this.answerModel.modelName = modelName;
    this.answerModel.isTrainer = true;
    this.answerModel.formateurName = `${this.indParam.AppParams.LoggedUser.Pre01PER} ${this.indParam.AppParams.LoggedUser.NomfaPER}`;
  }

  // Récupération de l'état du questionnaire
  getResult(result: string): void {
    this.closeBtn.nativeElement.click();
    this.GetTrainerStageInfo(this.idStage, this.modelType, this.modelName, this.stageName, this.questionnaireName, this.elQuest, true);
    this.resultQuest = result;
  }

  InitModalRaZ(Apprenant: LearnerDetail): void {
    this.apprenant = Apprenant;
  }

  RazInfoQuestionnaire(): void {
    this.dialogservice.showSplash(true);
    let stageDetail: DetailStageQuestionnaireModel = new DetailStageQuestionnaireModel();
    stageDetail = Object.assign({}, this.stageDetailModel);
    stageDetail.learnerList = new Array<LearnerDetail>();
    stageDetail.learnerList.push(this.apprenant);
    stageDetail.Mode = 'RaZApprenant';
    this.http.postHttp<QResult<DetailStageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getTrainerStageInfo/`, stageDetail).subscribe((data: QResult<DetailStageQuestionnaireModel>) => {
      this.closeRaZBtn.nativeElement.click();
      this.GetTrainerStageInfo(this.idStage, this.modelType, this.modelName, this.stageName, this.questionnaireName);
      this.dialogservice.showSplash(false);
    });
  }

  accordion(element: any, index: number): void {
    $('#btn' + index).toggleClass('accordionQuestActive');
    const panel: any = $('#panel' + index);
    if (panel.height() > 1) {
      panel.css('max-height', '0px');
    } else {
      panel.css('max-height', panel.prop('scrollHeight') + 'px');
    }
  }

  refresh(): void {
    this.dialogservice.showSplash(true);
    let dateDebut: string = '';
    let dateFin: string = '';
    // #region Refresh Formateur
    if (this.datePickerDebutInit.annee !== '0') {
      dateDebut = `${this.datePickerDebutInit.jour}-${this.datePickerDebutInit.mois}-${this.datePickerDebutInit.annee}`;
    }

    if (this.datePickerFinInit.annee !== '0') {
      dateFin = `${this.datePickerFinInit.jour}-${this.datePickerFinInit.mois}-${this.datePickerFinInit.annee}`;
    }

    this.http.getHttp<QResult<StageQuestionnaireModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/getInfoStage/trainer/${this.idFormateur}|${this.isCloture}|${dateDebut.replace(/\//g, '-')}|${dateFin.replace(/\//g, '-')}`).subscribe((data: QResult<StageQuestionnaireModel>) => {
      if (!data.HasError) {

        this.dialogservice.showSplash(false);

        this.listQuestionnaire.stages = data.Value.stages;

        this.stageDetailModel.learnerList = new Array<LearnerDetail>();
        this.stageName = '';
        this.questionnaireName = '';
        this.noteModel = new ChartQuestionnaireModel();
        this.noteModel.chart = new Array<ChartData>();
        this.statModel = new ChartQuestionnaireModel();
        this.statModel.chart = new Array<ChartData>();

        if (!this.listQuestionnaire.stages || this.listQuestionnaire.stages.length === 0) {
          this.toastservice.showInfoToast(this.indParam.getTrad('nostagetodisplay_QU'));
        }
      }
    });

    // #endregion
  }

  goback(): void {
    this.router.navigate(['webform/home']);
  }

  //#endregion



  download(learner: LearnerDetail) {
    this.disableDl = true;
    let model: AnswerModel = new AnswerModel();
    model = new AnswerModel();
    model.Mode = "toPdf";
    model.stageId = this.stageDetailModel.idStage;
    model.modelType = this.stageDetailModel.modelQuestionnaire;
    model.learnerId = learner.ident;
    model.isTrainer = true;
    model.learnerList = new Array<LearnerDetail>();
    model.learnerList.push(learner);

    model.modeQuestionnaire = "pdf";
    //  model.modeQuestionnaire = 'trainer';
    model.modelName = this.stageDetailModel.modelNameQuestionnaire;
    model.formateurName = `${this.indParam.AppParams.LoggedUser.Pre01PER} ${this.indParam.AppParams.LoggedUser.NomfaPER}`;
    this.toastservice.showInfoToast('Fichier en cours de génération ...');

    this.http.postHttp<QResult<AnswerModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/questionnaire/`, model).subscribe((data: QResult<AnswerModel>) => {
      if (!data.HasError) { }
      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = 'OPENFILE';
      fileModel.FullPath = data.Value.fileToDl;
      if (data.Value.fileToDl) {

        this.http.download(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Download`, fileModel).subscribe((response: any) => {
          const blob: Blob = new Blob([(response)], { type: 'application/pdf' });
          if (blob.size > 0) {
            if (window.navigator) {
              FileSaver.saveAs(blob, learner.ident + '.pdf');
            } else {
              const objectUrl = URL.createObjectURL(blob);
              window.open(objectUrl);
            }
          }
          this.indParam.showSplash(false);
          this.disableDl = false;
        });

      } else {
        this.disableDl = false;
      }
      this.indParam.showSplash(false);
    });
  }


  downloadAll() {
    this.disableDl = true;
    let model: AnswerModel = new AnswerModel();
    model = new AnswerModel();
    model.Mode = "toPdfAll";
    model.isTrainer = true;
    model.stageId = this.stageDetailModel.idStage;
    model.modelType = this.stageDetailModel.modelQuestionnaire;

    model.learnerList = this.stageDetailModel.learnerList;
    model.modeQuestionnaire = "pdf";
    //  model.modeQuestionnaire = 'trainer';
    model.modelName = this.stageDetailModel.modelNameQuestionnaire;
    model.formateurName = `${this.indParam.AppParams.LoggedUser.Pre01PER} ${this.indParam.AppParams.LoggedUser.NomfaPER}`;
    this.toastservice.showInfoToast('Fichier en cours de génération ...');


    this.http.postHttp<QResult<AnswerModel>>(`${this.indParam.AppParams.UrlQuestionnaireWS}api/questionnaire/`, model).subscribe((data: QResult<AnswerModel>) => {

      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = 'OPENFILE';
      fileModel.FullPath = data.Value.fileToDl;

      if (data.Value.fileToDl) {
        this.http.download(`${this.indParam.AppParams.UrlQuestionnaireWS}api/Download`, fileModel).subscribe((response: any) => {
          const blob: Blob = new Blob([(response)], { type: 'octet/stream' });
          if (blob.size > 0) {
            if (window.navigator) {
              FileSaver.saveAs(blob, this.stageDetailModel.modelQuestionnaire + '.zip');
            } else {
              const objectUrl = URL.createObjectURL(blob);
              window.open(objectUrl);
            }
          }
          this.disableDl = false;
          this.indParam.showSplash(false);
        });
      } else {
        this.disableDl = false;
      }
      this.indParam.showSplash(false);
    });
  }


  currentTab: string;
  toggleTab(tab: string) {
    this.currentTab = tab;
  }



}
